import PropTypes from 'prop-types'
import Grid from './Grid'
import React from 'react';

const PlayerGrid = ({ players, boardSize, style }) => {

    const styles = {
        gridContainerUnsolved: {
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            minWidth: boardSize,
            width: boardSize,
            backgroundColor: 'cyan',
            borderWidth: 3,
            borderStyle: 'solid',
            borderColor: 'black',
        },
        gridContainerSolved: {
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            minWidth: boardSize,
            width: boardSize,
            backgroundColor: 'cyan',
            borderWidth: 3,
            borderStyle: 'solid',
            borderColor: '#64ff80',
        },
    }

    // Construct the grid
    var grid = []
    for (let y = 0; y < players.length; y++) {
        grid.push([])
        for (let x = 0; x < players[y].length; x++) {
            grid[y].push(
                <div text-align='center' key={"pg"+y.toString()+","+x.toString()}>
                    <p>{players[y][x].name}</p>
                    <Grid
                        boardState={players[y][x].board}
                        style={players[y][x].solveTime ? styles.gridContainerSolved : styles.gridContainerUnsolved}
                        boardSize={boardSize}
                        cellClicked={() => { }}
                        isClickable={false}
                    /></div>)
        }
    }

    return (
        <div style={style}>
            {grid}
        </div>
    )
}

PlayerGrid.propTypes = {
    gridState: PropTypes.array,
    cellSize: PropTypes.number,
    style: PropTypes.object
}

export default PlayerGrid